import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { FormService } from '../../form.service';
import { Option } from '../../interfaces/option-interface';
import { atLeastOneTrueValidator } from '../../validators/custom-validators';
import { BaseControlValueAccessorComponent } from '../base-control-value-accessor/base-control-value-accessor.component';
import { TranslateService } from '@ngx-translate/core';
interface SelectorValues {
  id: string;
  text: string;
  numberOf: number;
  screen2Values?: any;
  screen3Values?: any;
}

interface SelectorFormValue {
  id: string;
  value: string;
  numberOf: number;
  screen2Values?: any;
  screen3Values?: any;
  text?: string;
}

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ListingComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingComponent extends BaseControlValueAccessorComponent implements OnInit, OnDestroy {
  @Input() requiredSelectedAmount: number | undefined;
  @Input() maximumSelectedAmount: number | undefined;
  @Input() options: Option[] = [];
  @Input() optionTitle: string | undefined = 'Lorem Ipsum';
  @Input() optionLead = 'Lorem Ipsum';
  @Input() selectorTitle = 'Lorem Ipsum';
  @Input() selectorLead = 'Lorem Ipsum';
  @Input() customOptionEnabled = false;
  @Input() ordering = true;
  @Input() cbOrder = 'ssz';
  @Input() cbOption = 'Küldőpiacok';
  @Input() cbCheckbox = 'Kiválasztott küldöpiac';
  @Input() selOrder = 'ssz';
  @Input() selOption = 'Küldőpiacok';
  @Input() selText = 'Kiválasztott küldöpiac';
  @Input() required : boolean;
  @Input() bottomLead = '';
  @Input() bottomText = '';
  @Input() formControl = new UntypedFormControl();
  @Input() screen2checkboxHeader = '';
  @Input() screen2Lead = '';
  @Input() screen2Title = '';
  @Input() screen2OptionHeader = '';
  @Input() screen2SerialHeader = '';
  @Input() activities: Option[] | undefined = undefined;
  @Input() regions: Option[] | undefined = undefined;
  @Input() screen3checkboxHeader = '';
  @Input() screen3Lead = '';
  @Input() screen3Title = '';
  @Input() screen3OptionHeader = '';
  @Input() screen3SerialHeader = '';
  @Input() screen2Required = false;
  @Input() screen3Required = false;

  optionHeading = true;
  selectedActivityIndex = 0;
  selectedRegionIndex = 0;
  selectorHeading = true;
  initialOptionLength = 0;
  selectedValues: SelectorValues[] = [];
  selectedFormGroupValue = 0;
  regionsFormGroupSelected = 0;
  firstFormCreated = false;
  firstCheckBoxGroup = new UntypedFormGroup({});
  regionsFormGroup = new UntypedFormGroup({});

  ngOnInit(): void {
    if (this.requiredSelectedAmount === null) {
      this.requiredSelectedAmount = 0;
    }
    if (this.maximumSelectedAmount === null) {
      this.maximumSelectedAmount = 6666;
    }
    if (this.formControl.value) {
      this.formControl.value.forEach((s: any) => {
        if (!this.options.some((o) => o.id === s.id)) {
          this.options.push(s);
        }
      });
    }
    if (!this.cbOrder.length && !this.cbOption.length && this.cbCheckbox.length) {
      this.optionHeading = false;
    }
    if (!this.selOrder.length && !this.selOption.length && this.selText.length) {
      this.selectorHeading = false;
    }
    this.initialOptionLength = this.options.filter((o) => o.id.length > 3).length;

    this.setValidators();
  }
  constructor(public formService: FormService, private readonly translate: TranslateService) {
    super();
  }

  ngOnDestroy(): void {
    if (this.firstFormCreated && !this.selectedValues[0]?.screen2Values) {
      this.getValuesandSetForm();
    }
  }
  setValidators(): void {
    if (this.required) {
      this.optionTitle = `${this.optionTitle} *`;
    }
    if (this.formControl.value) {
      this.selectedValues = this.transformFormValueToSelectedValue(this.formControl.value);
      if (this.selectedValues[0]?.screen2Values) {
        this.createForms();
      }
      return;
    }
    this.formControl.setValue([]);
  }

  selectCheckbox(event: Event, o: Option): void {
    event.preventDefault();
    if (this.formControl.disabled) {
      return;
    }
    if (this.formControl.untouched) {
      this.formControl.markAsTouched();
      this.formControl.updateValueAndValidity();
    }
    if (this.screen2Title && this.firstFormCreated) {
      this.firstFormCreated = false;
      this.regionsFormGroupSelected = 0;
      this.selectedActivityIndex = 0;
    }
    if (this.selectedValues.some((op) => op.id == o.id)) {
      this.selectedValues = this.selectedValues.filter((option) => option.id !== o.id);
      this.formControl.setValue(this.selectedValues);
      return;
    }
    const length = this.selectedValues.length + 1;
    this.selectedValues.push({ id: o.id, text: o.text, numberOf: length });
    this.selectedValues.sort((a, b) => {
      return +a.id - +b.id;
    });
    this.getValuesandSetForm();
    this.formControl.updateValueAndValidity();
  }
  isSelected(id: string): boolean {
    return this.selectedValues.some((s) => s.id === id);
  }

  addNewOption(): void {
    const id = this.options.length + 1;
    this.options.push({ id: id.toString(), text: '' });
  }

  changeSelectedInputToo($event: string, id: string): void {
    if (this.formControl.disabled) {
      return;
    }
    const selectedIndex = this.selectedValues.findIndex((s) => s.id === id);
    if (selectedIndex < 0) {
      return;
    }
    this.selectedValues[selectedIndex].text = $event;
  }

  removeLastOption(): void {
    if (this.options.length > this.initialOptionLength) {
      const deletedOption = this.options[this.options.length - 1];
      this.options.splice(this.options.length - 1, 1);
      const index = this.selectedValues.findIndex((s) => s.id === deletedOption.id);
      if (index > -1) {
        this.selectedValues.splice(index, 1);
      }
    }
  }

  hasDuplicates(): boolean {
    const array = this.selectedValues.map((s) => s.numberOf);
    if (array.some((a) => a === null)) {
      return false;
    }
    const noDups = new Set(array);

    return array.length !== noDups.size;
  }

  creteFormArrayFromSelectedValues(): void {
    const hasDuplicates = this.hasDuplicates();
    if (this.selectedValues.length < (this.requiredSelectedAmount ?? 1) || this.selectedValues.length > (this.maximumSelectedAmount ?? 3)) {
      Swal.fire(this.translate.instant('popup.rangeError', { min: this.requiredSelectedAmount, max: this.maximumSelectedAmount}), 'error');
    }
    if (hasDuplicates) {
      Swal.fire(this.translate.instant('popup.uniqueValuesError'), this.translate.instant('popup.numberInputPrompt'), 'error');
      return;
    }
    if (this.screen2Title) {
      this.createForms();
      this.getValuesandSetForm();
    }
  }

  createForms(): void {
    let i = 0;
    this.regionsFormGroup = new UntypedFormGroup({});
    this.firstCheckBoxGroup = new UntypedFormGroup({});
    this.selectedValues.forEach(() => {
      const fg = `fg${i}`;
      const firstCheckBoxGroupValidators = this.screen2Required ? [atLeastOneTrueValidator()] : [];
      const regionsFormGroupValidators = this.screen3Required ? [atLeastOneTrueValidator()] : [];

      this.firstCheckBoxGroup.addControl(fg, new UntypedFormGroup({}, firstCheckBoxGroupValidators));
      this.regionsFormGroup.addControl(fg, new UntypedFormGroup({}, regionsFormGroupValidators));
      const newFormGroup = this.firstCheckBoxGroup.get(fg) as UntypedFormGroup;
      const regionsFg = this.regionsFormGroup.get(fg) as UntypedFormGroup;

      this.activities?.forEach((activity, index) => {
        let startingValue = false;
        if (this.selectedValues[i]?.screen2Values?.length) {
          startingValue = this.selectedValues[i].screen2Values.includes(activity.id);
        }
        newFormGroup.addControl(`fc${index}`, new UntypedFormControl(startingValue));
      });
      this.regions?.forEach((region, index) => {
        let startingValue = false;
        if (this.selectedValues[i]?.screen3Values?.length) {
          startingValue = this.selectedValues[i].screen3Values.includes(region.id);
        }
        regionsFg.addControl(`fc${index}`, new UntypedFormControl(startingValue));
      });
      i++;
    });
    this.firstFormCreated = true;
  }

  getValueFromFormGroup(fg: UntypedFormGroup, valueToMapWith: Option[] | undefined): string[] {
    const boolanValues: any = [];
    Object.values(fg.value).forEach((v: any) => {
      let mappingIndex = -1;
      const boolean: any = [];
      Object.values(v).forEach((val) => {
        mappingIndex++;
        if (val) {
          boolean.push(valueToMapWith?.[mappingIndex].id);
        }
      });
      boolanValues.push(boolean);
    });
    return boolanValues;
  }

  setSelectedValues(): void {
    this.formControl.setValue(this.selectedValues);
  }
  getFormGroup(fg: AbstractControl, nameOfFg: string): UntypedFormGroup {
    const formGroup = fg as UntypedFormGroup;
    return formGroup.get(nameOfFg) as UntypedFormGroup;
  }
  setFormGroupSelected(i: number): void {
    this.selectedFormGroupValue = i;
  }

  hasValue(fg: UntypedFormGroup, formGroupIndex: number): boolean {
    const value = Object.values(fg.get(`fg${formGroupIndex}`)?.value);
    if (value.includes(true)) {
      return true;
    }
    return false;
  }

  getValuesandSetForm(): void {
    const screen2Values = this.getValueFromFormGroup(this.firstCheckBoxGroup, this.activities);
    const screen3Values = this.getValueFromFormGroup(this.regionsFormGroup, this.regions);
    this.selectedValues.forEach((f, index) => {
      f['screen2Values'] = screen2Values[index];
      f['screen3Values'] = screen3Values[index];
    });
    this.formControl.setValue(this.selectedValues);
  }

  private transformFormValueToSelectedValue(formValues: SelectorFormValue[]): SelectorValues[] {
    return formValues.map((formValue: any) => ({ ...formValue, text: formValue.value ? formValue.value : formValue.text }));
  }
}
